import React, { Fragment, useMemo } from 'react';
import { useGetDependeciesByUserLogged, useLocation, useRefundStates } from '../../../../share';
import { Row, Col, Button, Divider } from 'antd';
import { FormSelect, FormInput, FormDatePicker, CustomText } from '../../../../components';
import dayjs from 'dayjs';
import { DeleteOutlined } from '@ant-design/icons';

const AdvancedFilters: React.FC<any> = ({formik, filters, setFilters }: any) => {
  const [filterSelected, setFilterSelected] = React.useState<{ name: string, id: string, type: string, fetchData?: any[] }>();

  const { data: refundStates } = useRefundStates();
  const { data: dependencies } = useGetDependeciesByUserLogged({ model: "RefundPetition"});
  const { data: location } = useLocation();
  
  const filterStatus = useMemo(() => {
    const notAllowedIds = [15, 29];
    return refundStates?.filter((status: any) => !notAllowedIds.includes(status?.id));
  }, [refundStates]);

  const filterOptions = [
    { name: 'Dependencia', id: 'dependency_id', type: 'select', fetchData: dependencies },
    { name: 'Ubicación', id: 'location_id', type: 'select', fetchData: location },
    { name: 'Estado solicitud', id: 'status_id', type: 'select', fetchData: filterStatus },
  ];


  const handleAddFilter = () => {
    let item = {value: formik.values.filter_value, name: '', filter: {...filterSelected}};

    if (filterSelected?.type === 'date') {
      item.value = dayjs(formik.values.filter_value).format('YYYY-MM-DD');
    }

    if (filterSelected?.type === 'select') {
      item.name = filterSelected?.fetchData?.find((value) => value.id === formik.values.filter_value)?.name;
    }

    setFilters({...filters, [formik.values.filter_id]: item})

    setFilterSelected(undefined);
    formik.setFieldValue('filter_value', undefined);
    formik.setFieldValue('filter_id', undefined);
  };

  const handleRemoveFilter = (filterId: string) => {

    const filtersCopy = {...filters};
    delete filtersCopy[filterId];

    setFilters({...filtersCopy});
  };

  
  return (
    <Fragment>
      <Row gutter={[16, 16]} align="middle" style={{ flexWrap: 'wrap', minWidth: 400 }}>
        <Col xs={24} sm={12}>
          <FormSelect
            label="Seleccionar filtro"
            name="select_filter"
            placeholder="Seleccionar..."
            value={formik.values.filter_id}
            options={filterOptions}
            error={formik.errors.filter_id}
            touched={formik.touched.filter_id}
            onChange={(value) => {
              setFilterSelected(filterOptions.find(item => item.id === value));
              formik.setFieldValue('filter_value', '');
              formik.setFieldValue('filter_id', value);
            }}
            onBlur={formik.handleBlur}
          />
        </Col>
        
        <Col xs={24} sm={12}>
          {filterSelected?.type === 'select' && (
            <FormSelect
              label=""
              name="filter_value"
              placeholder="Seleccione"
              value={formik.values.filter_value}
              options={filterSelected?.fetchData || []}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={(value) => formik.setFieldValue('filter_value', value)}
              onBlur={formik.handleBlur}
            />
          )}
          {filterSelected?.type === 'text' && (
            <FormInput
              label={''}
              name="filter_value"
              placeholder="Ingrese valor"
              value={formik.values.filter_value}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          )}
          {filterSelected?.type === 'date' && (
            <FormDatePicker
              label=""
              name="filter_value"
              value={formik.values.filter_value}
              error={formik.errors.filter_value}
              touched={formik.touched.filter_value}
              onChange={(value) => formik.setFieldValue('filter_value', value)}
              onBlur={formik.handleBlur}
            />
          )}
        </Col>
        <Col xs={24} style={{ textAlign: "right", marginTop: 8, width: '100%' }}>
          <Button type="dashed" disabled={!formik.values.filter_value || !formik.values.filter_value} onClick={handleAddFilter} style={{ minWidth: 120 }}>
            Agregar Filtro
          </Button>
        </Col>
      </Row>
      <Divider />
      {Object.keys(filters).map((filterId: string) => {
        return (
          <Row gutter={[16, 16]} align="middle" key={filterId}>
            <Col xs={12} style={{ border: '1px dashed rgb(168, 168, 168)', borderRadius: '5px', margin: '6px 4px', padding: '3px', backgroundColor: 'rgb(239, 240, 246)' }}><CustomText strong={true} text={filters[filterId]?.filter?.name} /> </Col>
            <Col xs={9} style={{ border: '1px dashed rgb(168, 168, 168)', borderRadius: '5px', margin: '6px 4px', padding: '3px', backgroundColor: 'rgb(239, 240, 246)'  }}><CustomText text={filters[filterId]?.name || filters[filterId]?.value} /> </Col>
            <Col xs={2} style={{ textAlign: "right" }}><Button type="link" onClick={() => handleRemoveFilter(filterId)} icon={<DeleteOutlined />} /></Col>
          </Row>
        );
      })}
      {!Object.keys(filters).length && (<CustomText strong={true} centered={true} text="No tiene filtros agregados" />)}
      <Divider />

    </Fragment>
  );
};

export default AdvancedFilters;
